<div class="pt-explain">
  <!-- Properties table -->
  @if (showProperties()) {
    <div class="pt-explain__table" (mouseleave)="onPropertyLeave()">
      <div class="pt-explain__header">
        <span class="pt-explain__col-property">Property</span>
        <span class="pt-explain__col-meaning">Meaning</span>
        <span class="pt-explain__col-example">Example</span>
      </div>

      @for (prop of renderedProperties(); track prop.id) {
        <div
          class="pt-explain__row"
          [class.pt-explain__row--active]="activePropertyId() === prop.id"
          (mouseenter)="onPropertyHover(prop.id)"
        >
          <span class="pt-explain__col-property" [innerHTML]="prop.propertyHtml"></span>
          <span class="pt-explain__col-meaning">{{ prop.meaning }}</span>
          <span class="pt-explain__col-example" [innerHTML]="prop.exampleHtml"></span>
        </div>
      }
    </div>

    <p class="pt-explain__hint">Hover a property above to see it highlighted</p>
  }

  <!-- Binomial expansion -->
  @if (showExpansion()) {
    @if (hoverStyleHtml(); as style) {
      <span [innerHTML]="style" style="display: none"></span>
    }
    <div class="pt-expansion" (mouseover)="onExpansionMouseover($event)" (mouseleave)="onExpansionMouseleave()">
      <div class="pt-expansion__section">
        <span class="pt-expansion__label">Binomial Theorem</span>
        <div class="pt-expansion__formula" [innerHTML]="binomialTheoremGeneralHtml"></div>
      </div>
      <div class="pt-expansion__divider"></div>
      <div class="pt-expansion__section">
        <span class="pt-expansion__label">Worked Expansion</span>
        <div class="pt-expansion__power-control">
          <div class="pt-expansion__formula pt-expansion__formula--expression" [innerHTML]="expressionHtml()"></div>
          <div class="pt-expansion__power-btns">
            <dojo-button
              class="pt-expansion__power-btn"
              fill="solid"
              size="s"
              [disabled]="power() <= 0"
              (click)="onPowerChange(power() - 1)"
              >−</dojo-button
            >
            <dojo-button
              class="pt-expansion__power-btn"
              fill="solid"
              size="s"
              [disabled]="power() >= 19"
              (click)="onPowerChange(power() + 1)"
              >+</dojo-button
            >
          </div>
        </div>
        <div class="pt-expansion__formula pt-expansion__formula--product" [innerHTML]="productHtml()"></div>
        <div class="pt-expansion__formula" [innerHTML]="symbolicHtml()"></div>
        <div class="pt-expansion__formula" [innerHTML]="expandedHtml()"></div>
      </div>
    </div>
  }

  <!-- Triangle -->
  <dojo-pascals-triangle
    [params]="effectiveParams()"
    [height]="height()"
    [highlightFn]="highlightFn()"
    [activeCell]="activeCell()"
    [hoveredCell]="hoveredCell()"
    [activeRIndex]="activeR()"
    [selectable]="false"
    (cellHover)="onTriangleCellHover($event)"
    (cellClick)="onTriangleCellClick($event)"
  />

  @if (showExpansion() && !generalTermHtml()) {
    <p class="pt-explain__hint">Click a coefficient to see its term breakdown</p>
  }

  <!-- General term + detail tabs — always in DOM to avoid first-click style injection flash -->
  <div class="pt-detail-tabs" [class.hidden]="!generalTermHtml()">
    @if (generalTermHtml(); as termHtml) {
      <!-- General term — always visible -->
      <div class="pt-expansion__section">
        <span class="pt-expansion__label">Term Breakdown</span>
        @if (termBreakdownHintHtml(); as hint) {
          <p class="pt-expansion__explanation-text" [innerHTML]="hint"></p>
        }
        <div class="pt-expansion__formula" style="margin-bottom: 10px" [innerHTML]="termHtml"></div>
      </div>

      <!-- Binomial Tree / Coefficient Calculation tabs -->
      <div class="pt-detail-tabs__divider"></div>
    }
    <mat-tab-group
      class="custom-mat-tab size-s"
      mat-stretch-tabs="false"
      mat-align-tabs="start"
      [selectedIndex]="activeDetailTab()"
      (selectedIndexChange)="activeDetailTab.set($event)"
    >
      @if (showTree()) {
        <mat-tab label="Binomial Tree">
          @if (treeExplanationHtml(); as treeHint) {
            <p class="pt-expansion__explanation-text" [innerHTML]="treeHint"></p>
          }
          <dojo-tree-chart [params]="treeParams()" [matchingPaths]="treeMatchingPaths()" [color]="activeColorName()" />
        </mat-tab>
      }
      <mat-tab label="Coefficient Calculation">
        @if (explanationParts(); as parts) {
          <div class="pt-expansion">
            @for (part of parts; track $index; let first = $first) {
              @if (!first) {
                <div class="pt-expansion__divider"></div>
              }
              <div class="pt-expansion__section">
                @if (part.label) {
                  <span class="pt-expansion__label">{{ part.label }}</span>
                }
                @if (part.textHtml) {
                  <p class="pt-expansion__explanation-text" [innerHTML]="part.textHtml"></p>
                }
                @if (part.formulaHtml) {
                  <div class="pt-expansion__formula" [innerHTML]="part.formulaHtml"></div>
                }
              </div>
            }
          </div>
        }
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
